import { render } from "./CardResultHome.vue?vue&type=template&id=3136a21a&scoped=true"
import script from "./CardResultHome.vue?vue&type=script&lang=js"
export * from "./CardResultHome.vue?vue&type=script&lang=js"

import "./CardResultHome.vue?vue&type=style&index=0&id=3136a21a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3136a21a"]])

export default __exports__